import type { RegisterParams } from '@common/workflow/serviceActivityRegistry';
import { CustomControlCode } from '@common/enums';
import { ServiceActivityRegistry } from '@common/workflow/serviceActivityRegistry';
import { hearingLossAssessmentSectionsV1 } from './hearingLossAssessment/hearingLossAssessmentV1';
import { hearingLossAssessmentSectionsV2 } from './hearingLossAssessment/hearingLossAssessmentV2';
import { hearingLossAssessmentSectionsV3 } from './hearingLossAssessment/hearingLossAssessmentV3';
import { hearingLossAudiologistConsultSections } from './hearingLossAudiologistConsult/hearingLossAudiologistConsult';
import { hearingLossAudiologistFollowUpConsultSections } from './hearingLossAudiologistFollowUpConsult/hearingLossAudiologistFollowUpConsult';
import { hearingLossExaminationSectionsV1 } from './hearingLossExamination/hearingLossExaminationV1';
import { hearingLossExaminationSectionsV2 } from './hearingLossExamination/hearingLossExaminationV2';

const registryElements: RegisterParams[] = [
    {
        customControlCode: CustomControlCode.HearingLossAssessment,
        sections: hearingLossAssessmentSectionsV1,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HearingLossAssessment,
        sections: hearingLossAssessmentSectionsV2,
        version: 2,
    },
    {
        customControlCode: CustomControlCode.HearingLossAssessment,
        sections: hearingLossAssessmentSectionsV3,
        version: 3,
    },
    {
        customControlCode: CustomControlCode.HearingLossExamination,
        sections: hearingLossExaminationSectionsV1,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HearingLossExamination,
        sections: hearingLossExaminationSectionsV2,
        version: 2,
    },
    {
        customControlCode: CustomControlCode.HearingLossAudiologistConsult,
        sections: hearingLossAudiologistConsultSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HearingLossAudiologistFollowUpConsult,
        sections: hearingLossAudiologistFollowUpConsultSections,
        version: 1,
    },
];

ServiceActivityRegistry.instance.registerAll(registryElements);
